<template>
  <b-dropdown offset="200" right>
    <template slot="button-content">
      {{dateRangeText}}
    </template>
    <div class='dropdown-content'>
      <b-form @submit="onSubmit" inline>
        <div class="form-group">
          <label class="date-label">Date range</label>
          <b-form-select
            :options="defaultDateRanges"
            class='date-range-select'
            v-model="range"
          />
          <datepicker
            :bootstrap-styling="true"
            class="datepicker"
            v-model="startDate"
            :disabled="!customDates"
          />
          -
          <datepicker
            :bootstrap-styling="true"
            class="datepicker"
            v-model="endDate"
            :disabled="!customDates"
          />
        </div>
        <div class='form-group'>
          <label class="date-label">Compare to</label>
          <b-form-select
            class='date-range-select'
            :options="compareToOptios"
            v-model="compareTo"
          />
          <datepicker
            :bootstrap-styling="true"
            class="datepicker"
            v-model="compareToStartDate"
            :disabled="!customCompareDates"
          />
          -
          <datepicker
            :bootstrap-styling="true"
            class="datepicker"
            v-model="compareToEndDate"
            :disabled="!customCompareDates"
          />
        </div>
      </b-form>
    </div>
  </b-dropdown>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import {mapGetters, mapMutations} from 'vuex'

export default {
  name: 'CompareDatesSelector',
  components: {
    Datepicker
  },
  created () {
  },
  methods: {
    ...mapMutations([
      'setRange',
      'setCompareTo',
      'setCompareDates',
      'setDates'
    ]),
    onSubmit () {
    }
  },
  computed: {
    ...mapGetters([
      'reportDates',
      'defaultDateRanges',
      'datesParams',
      'compareToOptios'
    ]),
    dateRangeText: function () {
      return `${this.reportDates.startDate} - ${this.reportDates.endDate}`
    },
    range: {
      get () {
        return this.datesParams.range
      },
      set (value) {
        this.setRange(value)
      }
    },
    compareTo: {
      get () {
        return this.datesParams.compareTo
      },
      set (value) {
        this.setCompareTo(value)
      }
    },
    startDate: {
      get () {
        return this.reportDates.startDate
      },
      set (value) {
        this.setDates({key: 'startDate', date: value})
      }
    },
    endDate: {
      get () {
        return this.reportDates.endDate
      },
      set (value) {
        this.setDates({key: 'endDate', date: value})
      }
    },
    compareToStartDate: {
      get () {
        return this.reportDates.compareStartDate
      },
      set (value) {
        this.setCompareDates({key: 'startDate', date: value})
      }
    },
    compareToEndDate: {
      get () {
        return this.reportDates.compareEndDate
      },
      set (value) {
        this.setCompareDates({key: 'endDate', date: value})
      }
    },
    customDates () {
      return this.datesParams.range === 'Custom Dates'
    },
    customCompareDates () {
      return this.datesParams.compareTo === 'Custom Dates'
    }

  }
}

</script>

<style scoped>
@media (min-width: 1025px) {
  >>> .dropdown-menu{
    width: 620px
  }
  >>> .vdp-datepicker__calendar{
    border: 0px
  }
  >>> .form-control {
    padding: 0;
    margin: 5px;
  }
  .dropdown-content {
    width: 600px
  }
  .date-range-select{
    height: 25px!important
  }
  .datepicker {
    width: 120px;
    text-align: center;
  }
  .controls {
    margin-bottom: 10px
  }
  .date-label {
    width: 100px
  }
}
@media (max-width: 480px) {
}
</style>



// WEBPACK FOOTER //
// src/components/selectors/CompareDatesSelector.vue